import useMousetrap from "react-hook-mousetrap";
import { useProviderCamera } from "./provider/useProviderCamera";
import { useProviderMicrophone } from "./provider/useProviderMicrophone";

export const useKeyboardShortcuts = () => {
  const { toggleCamera } = useProviderCamera();
  const { toggleMicrophone } = useProviderMicrophone();

  useMousetrap("shift+v", () => {
    toggleCamera();
  });

  useMousetrap("shift+m", () => {
    toggleMicrophone();
  });
};
